import client from 'client'
import slugify from 'utils/slugify'

export const fetchStates = country =>
  client().get(`/countries/${slugify(country)}/regions`)
